import React from 'react';

import styled from 'styled-components';

import useCountryName from '@hooks/CachedLists/UseCountryName';

import { NwLinkButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const SiderContent = styled.div`
    width: 350px;
    border-right: ${(props) => props.theme.DarkerBorder};
    font-size: 13px;
    padding-left: 1rem;
    .company-name {
        font-size: 18px;
        font-weight: bold;
        margin: 1rem 0;
    }
    .contact-info {
        display: flex;
        flex-direction: row;
        margin: 1rem 0;
        .contact-detail {
            margin-left: 1rem;
        }
    }
    .addressNote {
        margin: 4rem 0 2rem 0;
    }
`;

const PaymentPageSider = ({ paymentData, onShowEditDrawer }) => {
    const { BillingInfo } = paymentData;
    const BillingCountryName = useCountryName(BillingInfo.Country);

    return (
        <>
            <SiderContent>
                <div className="company-name">{BillingInfo.CompanyName}</div>
                <div>{BillingInfo.Street}</div>
                <div>{`${BillingInfo.Zip} ${BillingInfo.City}, ${BillingInfo.State}`}</div>
                <div>{BillingCountryName}</div>
                <div className="contact-info">
                    {(BillingInfo.ContactName || BillingInfo.ContactPhone || BillingInfo.ContactEmail) && (
                        <NwIcon size="3x" icon={byPrefixAndName.fasl['address-book']} />
                    )}
                    <div className="contact-detail">
                        <div>{BillingInfo.ContactName}</div>
                        <div>{BillingInfo.ContactPhone}</div>
                        <div>{BillingInfo.ContactEmail}</div>
                    </div>
                </div>
                <div className="contact-info">
                    {(BillingInfo.ContactName2 || BillingInfo.ContactPhone2 || BillingInfo.ContactEmail2) && (
                        <NwIcon size="3x" icon={byPrefixAndName.fasl['address-book']} />
                    )}
                    <div className="contact-detail">
                        <div>{BillingInfo.ContactName2}</div>
                        <div>{BillingInfo.ContactPhone2}</div>
                        <div>{BillingInfo.ContactEmail2}</div>
                    </div>
                </div>
                <div className="addressNote">
                    <div>{paymentData.AddressNote}</div>
                    <NwLinkButton
                        onClick={() => onShowEditDrawer()}
                        label={`${paymentData.AddressNote ? 'Edit' : 'Add'} an Address Additional Text`}
                    />
                </div>
            </SiderContent>
        </>
    );
};

export default PaymentPageSider;
